import classnames from 'classnames';
import React from 'react';

import { formatTransferPrice } from '@wetransfer/transfer/helper/paidTransfers';
import Browser from '@wetransfer/transfer/modules/concorde-browser';

import styles from './PriceLabel.module.scss';
import { PriceLabelProps } from './types';

export const PriceLabel: React.FC<PriceLabelProps> = React.memo(
  function PriceLabel({ price, currency }) {
    return (
      <div
        className={classnames(styles.root, {
          [styles.rootHasSpacing]: !Browser.isMobile,
        })}
        data-test-id="paidTransfer_priceLabel"
      >
        <h6 className={styles.label}>{formatTransferPrice(price, currency)}</h6>
      </div>
    );
  }
);
